import { Container } from "reactstrap";
import styles from './styles.module.scss';

export const Content = ({
  className,
  content
}) => {

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <div className="mainContent" dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </section>
  );

}

export default Content;
